import { IAuthentication } from 'interfaces/IAuthentication'
import { ILogin } from 'interfaces/ILogin'

import { api as apiService, ApiService } from './api'

class AuthenticationService {
  constructor(private readonly api: ApiService) {}

  public postLogin = async (login: ILogin): Promise<IAuthentication> => {
    return this.api.post(authUrl + '/v2/token', login)
  }

  async getTwofactorsUsers() {
    return await this.api.get(`${authUrl}/v2/two-factors`)
  }

  async postTwofactorsUsers() {
    return await this.api.post(`${authUrl}/v2/two-factors`)
  }

  async patchTwofactorsUsers(secretKey: string) {
    return await this.api.patch(`${authUrl}/v2/two-factors/${secretKey}`)
  }

  async patchResetBlock(id: number) {
    const url = `${authUrl}/v2/user/${id}/block`
    return await this.api.patch(url)
  }

  async deleteTwofactorsUsers(secretKey: string) {
    return await this.api.delete(`${authUrl}/v2/two-factors/${secretKey}`)
  }
}
const authUrl = process.env.REACT_APP_API_AUTH
export const authenticationService = new AuthenticationService(apiService)
